import api from '..';
import config from '../../config';

export const getClientCredential = () => {
  const body = {
    grant_type: 'client_credentials',
    audience: config.audience,
  };
  return api.postUrlFormEncoded('/auth', body);
};

export const createUser = () => {
  const body = { anonymous: true };
  return getClientCredential()
    .then(({ data }) => {
      return api.post('/users', body, data);
    });
};

export const updateUserDisplayName = (username, displayName, auth, setAuth) => {
  const body = { username: username, display_name: displayName };
  return api.put(`/users/${username}`, body, auth, setAuth);
};

let refreshTokenPromise = null;
export const refreshToken = (refToken) => {
  if (refreshTokenPromise) {
    return refreshTokenPromise;
  }
  const body = {
    grant_type: 'refresh_token',
    refresh_token: refToken,
  };
  refreshTokenPromise = api.postUrlFormEncoded('/auth', body)
    .finally(() => {
      refreshTokenPromise = null;
    });
  return refreshTokenPromise;
};
